(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        if (this.elements.button && this.elements.panel) {
          this.elements.button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.openSelector(event);
          });
          this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
          this.addEventListener('click', (event) => {
            event.stopPropagation();
          });
          this.querySelectorAll('a').forEach(item => {
            item.addEventListener('click', (event) => {
              event.stopPropagation();
              this.onItemClick(event);
            });
          });
          
          document.addEventListener('click', (event) => {
            if (!this.contains(event.target) && !this.elements.panel.hasAttribute('hidden')) {
              this.hidePanel();
            }
          });
        }
      }

      hidePanel() {
        if (this.elements.button && this.elements.panel) {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        if (this.elements.button) this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (!form) return;
        
        const input = this.querySelector('input[name="language_code"], input[name="country_code"]');
        if (!input) return;
        
        const selectedValue = event.currentTarget.dataset.value;
        if (!selectedValue) return;
        
        if (input.value === selectedValue) {
          this.hidePanel();
          return;
        }
        
        input.value = selectedValue;
        
        let hiddenMethod = form.querySelector('input[name="_method"]');
        if (!hiddenMethod) {
          hiddenMethod = document.createElement('input');
          hiddenMethod.type = 'hidden';
          hiddenMethod.name = '_method';
          hiddenMethod.value = 'put';
          form.appendChild(hiddenMethod);
        }
        
        this.hidePanel();
        form.submit();
      }

      openSelector(event) {
        if (event) {
          event.stopPropagation();
        }
        if (this.elements.button && this.elements.panel) {
          const isHidden = this.elements.panel.hasAttribute('hidden');
          this.elements.button.focus();
          if (isHidden) {
            this.elements.panel.removeAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', 'true');
          } else {
            this.hidePanel();
          }
        }
      }

      closeSelector(event) {
        if (!this.elements.panel || !this.elements.button) return;
        
        const isClickInside = this.contains(event.relatedTarget);
        const isButton = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        
        if (!isClickInside || isButton) {
          this.hidePanel();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  document.addEventListener('DOMContentLoaded', function() {
    const closeTopBtn = document.querySelector('.menu-drawer__close-top-btn');
    const menuDrawer = document.querySelector('#menu-drawer');
    const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
    
    if (closeTopBtn && menuDrawerDetails) {
      closeTopBtn.addEventListener('click', function() {
        if (menuDrawerDetails instanceof HTMLDetailsElement) {
          menuDrawerDetails.removeAttribute('open');
           document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }
    
    // Also handle when menu drawer closes via other methods (e.g., clicking outside)
    if (menuDrawerDetails) {
      menuDrawerDetails.addEventListener('toggle', function() {
        if (!menuDrawerDetails.hasAttribute('open')) {
          // Remove overflow-hidden classes from body when menu closes
          document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }

    const localizationSelects = document.querySelectorAll('.menu-drawer__localization-select');
    localizationSelects.forEach(select => {
      select.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      select.addEventListener('change', function(event) {
        event.stopPropagation();
      });
      select.addEventListener('mousedown', function(event) {
        event.stopPropagation();
      });
    });

    const resetButton = document.querySelector('.menu-drawer__search .reset__button');
    if (resetButton) {
      resetButton.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      resetButton.addEventListener('mousedown', function(event) {
        event.stopPropagation();
      });
    }

    const searchForm = document.querySelector('.menu-drawer__search form');
    if (searchForm) {
      searchForm.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      searchForm.addEventListener('submit', function(event) {
        event.stopPropagation();
      });
    }

    const searchInput = document.querySelector('.menu-drawer__search .search__input');
    const resetButtonMenuDrawer = document.querySelector('.menu-drawer__search .reset__button');
    
    if (searchInput && resetButtonMenuDrawer) {
      searchInput.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      searchInput.addEventListener('focus', function(event) {
        event.stopPropagation();
      });
      
      function toggleResetButton() {
        if (searchInput.value.length > 0) {
          resetButtonMenuDrawer.classList.remove('hidden');
        } else {
          resetButtonMenuDrawer.classList.add('hidden');
        }
      }
      
      toggleResetButton();
      
      searchInput.addEventListener('input', function() {
        toggleResetButton();
      });
      
      const searchFormMenuDrawer = searchInput.closest('form');
      if (searchFormMenuDrawer) {
        searchFormMenuDrawer.addEventListener('reset', function() {
          setTimeout(toggleResetButton, 0);
        });
      }
    }

  });

  } catch(e) { console.error(e); }
})();
})();
